import { NumberSelector } from 'app/components/form/NumberSelector'
import { IQuestionsGroupContainerProps, QuestionsGroupContainer } from 'app/containers/PipelineSection/QuestionGroupContainer'
import { isValidPerson, Profile } from 'app/redux/Profile/model'
import { getBrandInfo } from 'config'
import * as React from 'react'
import { Button } from 'react-bootstrap'

interface IRetirementIntroContainerState {
  hasEnoughInfoForRetirement: boolean
}

class RetirementIntroContainer extends QuestionsGroupContainer<IQuestionsGroupContainerProps, IRetirementIntroContainerState> {
  rateOfReturnNS = 'ratesOfReturn.default'
  profile: Profile

  state: IRetirementIntroContainerState = {
    hasEnoughInfoForRetirement: false
  }

  componentWillMount() {
    this.onAppStateUpdate((appState) => {
      this.profile = appState.Profile.getNative('info')
      const member = this.profile.getHeadOfHousehold()
      const hasEnoughInfoForRetirement = isValidPerson(member)
      this.setState({ hasEnoughInfoForRetirement })
    })
  }

  render() {
    return (
      <section>
        <h1>Calculate Savings</h1>
        {getBrandInfo().markup.retirement.introduction.intro1}
        {this.state.hasEnoughInfoForRetirement ?
          <Button type="submit" bsStyle="primary" bsSize="lg">
            Get Started
          </Button>
          :
          <section>
            <h5 className="lead">
              To get started with this section, we'll need more information in your profile.
            </h5>
            <Button bsStyle="primary" bsSize="lg"
              onClick={() => this.relocate('#/profile', { redirectTo: '#/retirement/1', btnText: 'Get Started on Savings' })}>
              Update Profile
            </Button>
          </section>
        }
      </section>
    )
  }
}

const RetirementIntro = () => (
  <RetirementIntroContainer
    header="Savings Intro" icon="" />
)

export {
  RetirementIntro
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Retirement/Introduction/index.tsx